export class VendorProspectus {
  approved: false;
  prospectusNumber: string = null;
  aocNumber: string = null;
  approvalDate: Date = null;
  expirationDate: Date = null;
}
